import {Component, OnDestroy, OnInit} from '@angular/core';
import {AlertService, UserService} from "../services";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';

import {first} from "rxjs/operators";
import {VatRateService} from "../services/vatRate.service";
import { locale as polish } from './i18n/pl';
import {FuseTranslationLoaderService} from "../../../@fuse/services/translation-loader.service";

@Component({
    templateUrl: './vatRate.component.html',
    styleUrls: ['./vatRate.component.scss']
})
export class VatRateComponent implements OnDestroy, OnInit {
    rows: any[];
    loadingIndicator: boolean;
    reorderable: boolean;
    selected = [];

    // Private
    private _unsubscribeAll: Subject<any>;

    constructor(
        private userService: UserService,
        private vatRateService: VatRateService,
        private alertService: AlertService,
        private _fuseSidebarService: FuseSidebarService,
        private translationLoader: FuseTranslationLoaderService,
    ) {
        // Set the defaults
        this.loadingIndicator = true;
        this.reorderable = true;

        this.translationLoader.loadTranslations(polish);

        // Set the private defaults
        this._unsubscribeAll = new Subject();
    }

    ngOnInit() {
        this.vatRateService.getAll().pipe(first())
            .subscribe( res => {
                    this.rows = res;
                    this.loadingIndicator = false;
                },
                error => {
                    this.alertService.error(error);
                })
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }


    /**
     * Toggle the sidebar
     *
     * @param name
     */
    toggleSidebar(name): void
    {
        this._fuseSidebarService.getSidebar(name).toggleOpen();
    }
}
